import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CorpForm from './CorpForm';
import { fetchWithCorpId } from '../utils/api';

function CorpFormScreen({ mode, onSuccess, onCancel }) {
  const { id } = useParams();
  const [corpData, setCorpData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCorp = async () => {
      if (mode === 'edit' && id) {
        setLoading(true);
        try {
          const data = await fetchWithCorpId(`/corps/${id}`);
          setCorpData(data);
        } catch (err) {
          console.error('Error fetching corporation:', err);
          setError('Failed to load corporation data');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCorp();
  }, [mode, id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <CorpForm
        mode={mode}
        initialData={corpData}
        onSuccess={onSuccess}
        onCancel={onCancel}
      />
    </div>
  );
}

export default CorpFormScreen;
